import { PersonaFisicaDTO } from "./persona-fisica-dto";
import { PersonaGiuridicaDTO } from "./persona-giuridica-dto";

export class AltriSoggettiNoEsproprioDTO {
	codiceTipoAltroSoggetto: string;
	idPersona: string;
	personaFisica: PersonaFisicaDTO;
	personaGiuridica: PersonaGiuridicaDTO;
	codiceRegione: string;
}